import React from 'react'

var EventFormFieldText = React.createClass({
  propTypes: {
    form: React.PropTypes.string
  },
  render: function() {
    const { onChange, label, name, value, required } = this.props;
    return(
      <div className="form-group">
        <label className="col-lg-2 control-label">{label}{ required ? '*' : undefined }</label>
        <div className="col-lg-10">
          <input type="text" className="form-control" name={name} value={value} onChange={e => onChange({[name] : e.target.value })} />
        </div>
      </div>
    );
  }
});

export default EventFormFieldText;


// WEBPACK FOOTER //
// ./src/components/event_form_field_text.js